import { render, staticRenderFns } from "./SideMenuMaintenanceItem.vue?vue&type=template&id=79caf344&scoped=true"
import script from "./SideMenuMaintenanceItem.vue?vue&type=script&lang=js"
export * from "./SideMenuMaintenanceItem.vue?vue&type=script&lang=js"
import style0 from "./SideMenuMaintenanceItem.vue?vue&type=style&index=0&id=79caf344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79caf344",
  null
  
)

export default component.exports